/**
 * Tickets API Client - a project's tickets, each grouping every run of one
 * ticket key
 */

import type { TicketDetailResponse, TicketListResponse } from '@resolve-ai/shared';
import { fetchWithAuth } from './api-client';

/** Path of the ticket page listing every run of a ticket. */
export function ticketPath(projectId: string, ticketKey: string): string {
  return `/projects/${projectId}/tickets/${encodeURIComponent(ticketKey)}`;
}

export const ticketsApi = {
  /**
   * List a project's tickets, most recently run first
   */
  async list(
    projectId: string,
    params?: { cursor?: string; search?: string }
  ): Promise<TicketListResponse> {
    const queryParams = new URLSearchParams();
    if (params?.cursor) queryParams.append('cursor', params.cursor);
    if (params?.search) queryParams.append('search', params.search);

    const query = queryParams.toString();
    return fetchWithAuth<TicketListResponse>(
      `/projects/${projectId}/tickets${query ? `?${query}` : ''}`
    );
  },

  /**
   * Get every run of one ticket, with combined usage for admins
   */
  async get(projectId: string, ticketKey: string): Promise<TicketDetailResponse> {
    return fetchWithAuth<TicketDetailResponse>(`/projects/${projectId}/tickets/${encodeURIComponent(ticketKey)}`);
  },
};
